import React from 'react';
import { Row, Col } from 'react-bootstrap';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import TextInput from 'components/inputs/Input';
import PhoneNumberInput from 'components/inputs/PhoneNumberInput';
import Button from 'components/inputs/Button';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import SessionHeading from 'components/general/SessionHeading';
import { useDispatch } from 'react-redux';
import { SEND_CONTACT_EMAIL } from 'actions/legal';
import { toast } from 'react-toastify';

const ContactUs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const ContactSchema = Yup.object().shape({
    firstName: Yup.string(),
    lastName: Yup.string(),
    email: Yup.string().email('Invalid email').required('Email Address is required'),
    phone: Yup.string().required('Phone Number is required'),
    address: Yup.string(),
    message: Yup.string(),
  });

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    message: '',
  };

  return (
    <LayoutContainer>
      <AdminHeader title={t('header.contactUs')} />
      <div className="page-content-wrapper scrollable">
        <Card className="m-4">
          <div className="p-4">
            <SessionHeading text={t('header.contactUs')} />
            <Formik
              initialValues={initialValues}
              validationSchema={ContactSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const payload = {
                  message: {
                    'First Name': values.firstName,
                    'Last Name': values.lastName,
                    'Email': values.email,
                    'Phone': values.phone,
                    'Address': values.address,
                    'User Message': values.message,
                    subject: 'Inquiry from Website Contact Us',
                  },
                };
                dispatch({
                  type: SEND_CONTACT_EMAIL.REQUEST,
                  payload,
                  cb: () => {
                    toast.success('Thank you for contacting us! We will get back to you soon.');
                    resetForm();
                    setSubmitting(false);
                  },
                });
              }}
            >
              {({ values, errors, touched, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit} className="mt-4">
                  <Row>
                    <Col md={6} className="mb-3">
                      <TextInput
                        label="First Name"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        placeholder="First Name"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <TextInput
                        label="Last Name"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        placeholder="Last Name"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} className="mb-3">
                      <TextInput
                        isRequired
                        label="Email Address"
                        name="email"
                        type="email"
                        value={values.email}
                        onChange={handleChange}
                        placeholder="Email Address"
                        error={errors.email && touched.email ? errors.email : null}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <PhoneNumberInput
                        isRequired
                        label="Phone Number"
                        name="phone"
                        value={values.phone}
                        onChange={(value) => setFieldValue('phone', value)}
                        placeholder="Phone Number"
                        error={errors.phone && touched.phone ? errors.phone : null}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className="mb-3">
                      <TextInput
                        label="Address"
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                        placeholder="Address"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className="mb-3">
                      <TextInput
                        label="Enter Your Message"
                        name="message"
                        as="textarea"
                        rows="4"
                        value={values.message}
                        onChange={handleChange}
                        placeholder="Enter Your Message"
                      />
                    </Col>
                  </Row>
                  <div className="mb-4">
                    <p className="text-muted small">This is some text inside of a div block.</p>
                  </div>
                  <div>
                    <Button type="submit" disabled={isSubmitting} className="save-btn" style={{ minWidth: '150px' }}>
                      Send Message
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </LayoutContainer>
  );
};

export default ContactUs;
